import React from 'react';
import { Table, Space, Typography, Tooltip } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
import { DeleteIcon, EditIcon } from 'icons';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { getPage } from 'hooks/useUser';
import { Button } from 'components';
import WebsiteFilters from 'components/filters/WebsiteFilters';

const { Text } = Typography;

const WebQrsList = ({
  webQrs,
  loading,
  total,
  currentPage,
  pageSize,
  filters,
  shoppingCenters,
  loadingCompanies,
  onFiltersChange,
  onPageChange,
  handleDelete,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const pages = useRecoilValue(getPage);

  const columns = [
    {
      title: t('ID'),
      dataIndex: 'id',
      key: 'id',
      width: 80,
    },
    {
      title: t('Slug'),
      dataIndex: 'slug',
      key: 'slug',
    },
    {
      title: t('Outlet Village'),
      dataIndex: ['shopping_center', 'title'],
      key: 'shopping_center',
    },
    {
      title: t('Link generato'),
      dataIndex: 'link',
      key: 'link',
      render: (link) => (
        <Text 
          copyable={{
            onCopy: (e) => e.stopPropagation()
          }}
          ellipsis
          style={{ maxWidth: 200 }}
        >
          {link}
        </Text>
      ),
    },
    {
      title: t('Destinazione'),
      key: 'destination',
      render: (_, record) => {
        if (record.qr_link) {
          return t('Link esterno');
        } else if (record.file) {
          return t('File');
        }
        return t('Non definito');
      },
    },
    {
      title: t('Aperture'),
      dataIndex: 'count_open',
      key: 'count_open',
      align: 'center',
    },
    {
      title: t('Azioni'),
      key: 'actions',
      width: 180,
      render: (_, record) => (
        <Space size='middle'>
          {(pages?.ability?.can_read !== false ||
            record.can_read !== false) && (
            <Tooltip title={t('Visualizza')}>
              <Button
                type='secondary'
                icon={<EyeOutlined />}
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(`${record.id}`);
                }}
              />
            </Tooltip>
          )}
          {record.can_update !== false && (
            <Tooltip title={t('Modifica')}>
              <Button
                type='secondary'
                icon={<EditIcon />}
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(`${record.id}/edit`);
                }}
              />
            </Tooltip>
          )}
          {record.can_destroy !== false && (
            <Tooltip title={t('Elimina')}>
              <Button
                type='red'
                icon={<DeleteIcon />}
                onClick={(e) => {
                  e.stopPropagation();
                  handleDelete(record.id);
                }}
              />
            </Tooltip>
          )}
        </Space>
      ),
    },
  ];

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: 'calc(100vh - 180px)',
        padding: '0 24px',
      }}
    >
      <WebsiteFilters
        onFiltersChange={onFiltersChange}
        shoppingCenters={shoppingCenters}
        loading={loadingCompanies}
        filters={filters}
        showInsegna={false}
        showCategorie={false}
        enableSorting={false}
      />
      
      <Table
        columns={columns}
        dataSource={webQrs}
        rowKey='id'
        loading={loading}
        onRow={(record) => ({
          onClick: () => navigate(`${record.id}`),
          style: { cursor: 'pointer' }
        })}
        pagination={{
          current: currentPage,
          pageSize: pageSize,
          total: total,
          showSizeChanger: true,
          showQuickJumper: true,
          showTotal: (total, range) => 
            t('Paginazione elementi', { start: range[0], end: range[1], total }),
          onChange: onPageChange,
        }}
      />
    </div>
  );
};

export default WebQrsList;
